import React from 'react';
import { X } from 'lucide-react';
import { Button } from '../ui/button';

const PanelHeader = ({ onClose }) => (
  <div className="p-4 border-b border-white/20 flex justify-between items-center">
    <h2 className="font-semibold text-lg" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
      Propiedades de Imagen
    </h2>
    <Button variant="ghost" size="sm" onClick={onClose} className="hover:bg-white/50 dark:hover:bg-slate-700/50">
      <X className="w-4 h-4" />
    </Button>
  </div>
);

export default PanelHeader;
